import styled from 'styled-components';

export const PayrollPageContent = styled.div`
  width: 100%;
  height: 100%;
`

export const PayrollPageHeader = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  h1{
    font-size: 24px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.black}; 
    margin-bottom: 2px;
  }
  h2{
    font-size: 19px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.gray};
  }
  margin-bottom: 30px;
`

export const PayrollTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 32px;
`

